import React from 'react';
import { IIconProps, sizeMap } from './types';

export const SearchIcon = ({ className, size = 'medium' }: IIconProps) => {
  return (
    <svg
      className={className}
      width={sizeMap[size].width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5814 15.5814L23 23L13.446 13.446M13.446 13.446C14.7654 12.1266 15.5814 10.304 15.5814 8.2907C15.5814 4.26416 12.3172 1 8.2907 1C4.26416 1 1 4.26416 1 8.2907C1 12.3172 4.26416 15.5814 8.2907 15.5814C10.304 15.5814 12.1266 14.7654 13.446 13.446Z"
        stroke="currentcolor"
        strokeWidth={sizeMap[size].strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
